module.exports = __webpack_public_path__ + "static/media/flag-lt.ad802174.webp";